import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  #timeout = null

  submit() {
    this.element.requestSubmit()
  }

  submitAndDisable(event) {
    if (!event.target.value) return

    let hiddenInput = this.element.querySelector(`[data-submitted-name="${event.target.name}"]`)

    if (!hiddenInput) {
      hiddenInput = document.createElement("input")
      hiddenInput.type = "hidden"
      hiddenInput.dataset.submittedName = event.target.name
      this.element.appendChild(hiddenInput)
    }

    hiddenInput.name = event.target.name
    hiddenInput.value = event.target.value
    event.target.disabled = true
    this.submit()
  }

  debounceSubmit() {
    clearTimeout(this.#timeout)
    this.#timeout = setTimeout(() => this.submit(), 400)
  }
}
